// Screenshots shown inside Product Knowledge. The image files live in the app's public folder: public/pk/<file>.
// A screen page shows SCREEN_IMAGES[screenKey]; a workflow page shows WORKFLOW_IMAGES[workflowKey].
// Each entry: { file, en, ar }. A missing file is simply not shown (the page never breaks).
const BASE = (typeof process !== 'undefined' && process.env && process.env.PUBLIC_URL) || ''
export const imageUrl = (file) => `${BASE}/pk/${file}`
export const SCREEN_IMAGES = {
 "costcontrol": [
  {
   "file": "cc_screen.png",
   "en": "Cost Control — the main report. Screenshot — current CostSpace implementation",
   "ar": "رقابة التكلفة — التقرير الرئيسي. لقطة شاشة — التنفيذ الحالي في CostSpace"
  },
  {
   "file": "cc_summary_tab.png",
   "en": "Cost Control — Summary tab. Screenshot — current CostSpace implementation",
   "ar": "رقابة التكلفة — تبويب الملخص. لقطة شاشة — التنفيذ الحالي في CostSpace"
  },
  {
   "file": "cc_activity_report.png",
   "en": "Cost Control — Activity Report. Screenshot — current CostSpace implementation",
   "ar": "رقابة التكلفة — تقرير النشاط. لقطة شاشة — التنفيذ الحالي في CostSpace"
  }
 ],
 "takeoff": [
  {
   "file": "takeoff_full.png",
   "en": "Takeoff — the full screen. Screenshot — current CostSpace implementation",
   "ar": "الحصر — الشاشة كاملة. لقطة شاشة — التنفيذ الحالي في CostSpace"
  },
  {
   "file": "takeoff_toolbar.png",
   "en": "Takeoff — the toolbar. Screenshot — current CostSpace implementation",
   "ar": "الحصر — شريط الأدوات. لقطة شاشة — التنفيذ الحالي في CostSpace"
  },
  {
   "file": "ex_10.png",
   "en": "Takeoff: sheet c of the drawing office room (revision 3), with the measurement tools along the top and the measurements drawn over the plan.",
   "ar": "الحصر: الشيت c من المخطط office room (المراجعة 3)، مع أدوات القياس في الأعلى والقياسات المرسومة فوق المخطط."
  },
  {
   "file": "ex_11.png",
   "en": "Takeoff, right-hand panel: the sheet's calibration, the active takeoff item (Area-void, Aggregated Qty 125.14 m2) and the Capture into BOQ panel.",
   "ar": "الحصر، اللوحة اليمنى: معايرة الشيت، وبند الحصر الفعّال (Area-void، الكمية المجمّعة 125.14 م²)، ولوحة الالتقاط إلى جدول الكميات."
  }
 ],
 "quantification": [
  {
   "file": "module_rebar_slab.png",
   "en": "Quantification — the Rebar Slab module. Screenshot — current CostSpace implementation",
   "ar": "حساب الكميات — وحدة حديد البلاطة. لقطة شاشة — التنفيذ الحالي في CostSpace"
  },
  {
   "file": "module_excavation.png",
   "en": "Quantification — the Excavation module. Screenshot — current CostSpace implementation",
   "ar": "حساب الكميات — وحدة الحفر. لقطة شاشة — التنفيذ الحالي في CostSpace"
  }
 ],
 "resource-dictionary": [
  {
   "file": "ex_01.png",
   "en": "Resource Dictionary of the example tender: 16 active resources. Only identity is kept here (code, description, unit, type); prices come from Resource Rates.",
   "ar": "قاموس الموارد في المناقصة النموذجية: 16 مورداً فعّالاً. تُحفظ هنا الهوية فقط (الكود والوصف والوحدة والنوع)؛ أما الأسعار فتأتي من أسعار الموارد."
  }
 ],
 "cost-code-dictionary": [
  {
   "file": "ex_02.png",
   "en": "Cost Code Dictionary of the example tender: two codes, 03 20 00 Steel Reinforcement and 03 30 00 Concrete Placing, both active.",
   "ar": "قاموس أكواد التكلفة في المناقصة النموذجية: كودان، 03 20 00 Steel Reinforcement و03 30 00 Concrete Placing، وكلاهما فعّال."
  }
 ],
 "first-principles-library": [
  {
   "file": "ex_07.png",
   "en": "First-Principles Library, Resource Rates: each rate has its currency, the date it starts and the date it ends (Ongoing until another rate replaces it). The list also holds rates dated after the Pricing Date, for example MAT-EDGE in KWD from 2026-10-02, which this revision ignores.",
   "ar": "مكتبة المبادئ الأولى، أسعار الموارد: لكل سعر عملته وتاريخ بدايته وتاريخ نهايته (Ongoing حتى يحل محله سعر آخر). وتضم القائمة أيضاً أسعاراً مؤرخة بعد تاريخ التسعير، مثل MAT-EDGE بالدينار الكويتي من 2026-10-02، وتتجاهلها هذه المراجعة."
  },
  {
   "file": "ex_08.png",
   "en": "First-Principles Library, Crews: Excavation Crew A expanded, with its three members. The line at the bottom is a preview at today's rates (1,906.92 SAR/shift); a BOQ price uses the revision's Pricing Date and gives 1,913.04 (Stage 8).",
   "ar": "مكتبة المبادئ الأولى، الطواقم: Excavation Crew A مفتوح بأعضائه الثلاثة. السطر الأخير معاينة بأسعار اليوم (1,906.92 ريال/وردية)؛ أما سعر جدول الكميات فيستخدم تاريخ تسعير المراجعة ويعطي 1,913.04 (المرحلة 8)."
  },
  {
   "file": "ex_15.png",
   "en": "First-Principles Library, Productivity Library: the three productivity standards of the example tender. Excavation - general soil is open and shows its one factor, Rock pockets at -15%. (Its unit was typed as m3/shift, which is why the screen reads m3/shift/shift; the other two standards use m3 and m2.) Stage 8 shows them inside real prices.",
   "ar": "مكتبة المبادئ الأولى، مكتبة الإنتاجية: معايير الإنتاجية الثلاثة في المناقصة النموذجية. معيار Excavation - general soil مفتوح ويعرض عامله الوحيد، Rock pockets بنسبة -15%. (كُتبت وحدته m3/shift، ولذلك تقرأ الشاشة m3/shift/shift؛ أما المعياران الآخران فيستخدمان m3 وm2.) وتعرضها المرحلة 8 داخل أسعار حقيقية."
  },
  {
   "file": "ex_09.png",
   "en": "First-Principles Library, Exchange Rates: for the Pricing Date of 2026-09-27 the rate in force is EUR 4.20 (from 2026-09-25); the 4.10 rate starts after the Pricing Date.",
   "ar": "مكتبة المبادئ الأولى، أسعار الصرف: لتاريخ التسعير 2026-09-27 السعر الساري هو EUR 4.20 (من 2026-09-25)؛ أما السعر 4.10 فيبدأ بعد تاريخ التسعير."
  }
 ],
 "tender-workspace": [
  {
   "file": "ex_03.png",
   "en": "Tender Workspace: the tender's currency (SAR, locked once pricing exists), the linked CostSpace project, the Resource Dictionary and Cost Code Dictionary buttons, and the list of revisions.",
   "ar": "مساحة عمل المناقصة: عملة المناقصة (SAR، وتُقفل بمجرد وجود تسعير)، ومشروع CostSpace المرتبط، وزرا قاموس الموارد وقاموس أكواد التكلفة، وقائمة المراجعات."
  }
 ],
 "wbs": [
  {
   "file": "ex_04.png",
   "en": "Revision 1, WBS tab: the Finishes package selected, with its cost (145,219.71 SAR) and the seven BOQ items assigned to it.",
   "ar": "المراجعة 1، تبويب WBS: حزمة Finishes محددة، بتكلفتها (145,219.71 ريال) وبنود جدول الكميات السبعة المسندة إليها."
  }
 ],
 "boq-estimation": [
  {
   "file": "ex_05.png",
   "en": "Revision 1, BOQ tab: all 21 items with package, cost code, unit, quantity, direct cost, markup %, prices and quantity source.",
   "ar": "المراجعة 1، تبويب BOQ: كل البنود الـ21 مع الحزمة وكود التكلفة والوحدة والكمية والتكلفة المباشرة ونسبة الهامش والأسعار ومصدر الكمية."
  }
 ],
 "rate-build-up": [
  {
   "file": "ex_06.png",
   "en": "Rate Build-Up of item 1.02: the two Resource-Based lines, a direct cost of 183,680.00 SAR, 15.0% markup and a selling price of 211,232.00 SAR.",
   "ar": "بناء سعر البند 1.02: سطرا \"قائم على الموارد\"، بتكلفة مباشرة 183,680.00 ريال، وهامش 15.0%، وسعر بيع 211,232.00 ريال."
  }
 ],
 "direct-budget-review": [
  {
   "file": "ex_12.png",
   "en": "Direct Budget Review: Total Direct Budget 1,066,670.97 SAR across 20 activities and 21 resources, with 0 errors and 0 warnings.",
   "ar": "مراجعة الميزانية المباشرة: إجمالي الميزانية المباشرة 1,066,670.97 ريال عبر 20 نشاطاً و21 مورداً، بلا أخطاء ولا تحذيرات."
  }
 ],
 "indirect-budget-review": [
  {
   "file": "ex_13.png",
   "en": "Indirect Budget Review: total 252,333.68 SAR (Normal Indirect 125,000.00, Risk & Contingency 69,500.13, HO Overhead 57,833.55).",
   "ar": "مراجعة الميزانية غير المباشرة: الإجمالي 252,333.68 ريال (غير مباشر عادي 125,000.00، ومخاطر واحتياطي 69,500.13، ومصاريف مكتب رئيسي 57,833.55)."
  }
 ],
 "tender-summary": [
  {
   "file": "ex_14.png",
   "en": "Tender Summary: Tender Price 1,443,664.18 SAR, read straight from the calculation chain.",
   "ar": "ملخص المناقصة: سعر المناقصة 1,443,664.18 ريال، مقروءاً مباشرة من سلسلة الحساب."
  }
 ]
}
export const WORKFLOW_IMAGES = {
 "walkthrough_stage_01": [
  {
   "file": "ex_01.png",
   "en": "Resource Dictionary of the example tender: 16 active resources. Only identity is kept here (code, description, unit, type); prices come from Resource Rates.",
   "ar": "قاموس الموارد في المناقصة النموذجية: 16 مورداً فعّالاً. تُحفظ هنا الهوية فقط (الكود والوصف والوحدة والنوع)؛ أما الأسعار فتأتي من أسعار الموارد."
  },
  {
   "file": "ex_02.png",
   "en": "Cost Code Dictionary of the example tender: two codes, 03 20 00 Steel Reinforcement and 03 30 00 Concrete Placing, both active.",
   "ar": "قاموس أكواد التكلفة في المناقصة النموذجية: كودان، 03 20 00 Steel Reinforcement و03 30 00 Concrete Placing، وكلاهما فعّال."
  },
  {
   "file": "ex_07.png",
   "en": "First-Principles Library, Resource Rates: each rate has its currency, the date it starts and the date it ends (Ongoing until another rate replaces it). The list also holds rates dated after the Pricing Date, for example MAT-EDGE in KWD from 2026-10-02, which this revision ignores.",
   "ar": "مكتبة المبادئ الأولى، أسعار الموارد: لكل سعر عملته وتاريخ بدايته وتاريخ نهايته (Ongoing حتى يحل محله سعر آخر). وتضم القائمة أيضاً أسعاراً مؤرخة بعد تاريخ التسعير، مثل MAT-EDGE بالدينار الكويتي من 2026-10-02، وتتجاهلها هذه المراجعة."
  },
  {
   "file": "ex_08.png",
   "en": "First-Principles Library, Crews: Excavation Crew A expanded, with its three members. The line at the bottom is a preview at today's rates (1,906.92 SAR/shift); a BOQ price uses the revision's Pricing Date and gives 1,913.04 (Stage 8).",
   "ar": "مكتبة المبادئ الأولى، الطواقم: Excavation Crew A مفتوح بأعضائه الثلاثة. السطر الأخير معاينة بأسعار اليوم (1,906.92 ريال/وردية)؛ أما سعر جدول الكميات فيستخدم تاريخ تسعير المراجعة ويعطي 1,913.04 (المرحلة 8)."
  },
  {
   "file": "ex_15.png",
   "en": "First-Principles Library, Productivity Library: the three productivity standards of the example tender. Excavation - general soil is open and shows its one factor, Rock pockets at -15%. (Its unit was typed as m3/shift, which is why the screen reads m3/shift/shift; the other two standards use m3 and m2.) Stage 8 shows them inside real prices.",
   "ar": "مكتبة المبادئ الأولى، مكتبة الإنتاجية: معايير الإنتاجية الثلاثة في المناقصة النموذجية. معيار Excavation - general soil مفتوح ويعرض عامله الوحيد، Rock pockets بنسبة -15%. (كُتبت وحدته m3/shift، ولذلك تقرأ الشاشة m3/shift/shift؛ أما المعياران الآخران فيستخدمان m3 وm2.) وتعرضها المرحلة 8 داخل أسعار حقيقية."
  }
 ],
 "walkthrough_stage_02": [
  {
   "file": "ex_03.png",
   "en": "Tender Workspace: the tender's currency (SAR, locked once pricing exists), the linked CostSpace project, the Resource Dictionary and Cost Code Dictionary buttons, and the list of revisions.",
   "ar": "مساحة عمل المناقصة: عملة المناقصة (SAR، وتُقفل بمجرد وجود تسعير)، ومشروع CostSpace المرتبط، وزرا قاموس الموارد وقاموس أكواد التكلفة، وقائمة المراجعات."
  }
 ],
 "walkthrough_stage_03": [
  {
   "file": "ex_04.png",
   "en": "Revision 1, WBS tab: the Finishes package selected, with its cost (145,219.71 SAR) and the seven BOQ items assigned to it.",
   "ar": "المراجعة 1، تبويب WBS: حزمة Finishes محددة، بتكلفتها (145,219.71 ريال) وبنود جدول الكميات السبعة المسندة إليها."
  },
  {
   "file": "ex_05.png",
   "en": "Revision 1, BOQ tab: all 21 items with package, cost code, unit, quantity, direct cost, markup %, prices and quantity source.",
   "ar": "المراجعة 1، تبويب BOQ: كل البنود الـ21 مع الحزمة وكود التكلفة والوحدة والكمية والتكلفة المباشرة ونسبة الهامش والأسعار ومصدر الكمية."
  }
 ],
 "walkthrough_stage_04": [
  {
   "file": "ex_10.png",
   "en": "Takeoff: sheet c of the drawing office room (revision 3), with the measurement tools along the top and the measurements drawn over the plan.",
   "ar": "الحصر: الشيت c من المخطط office room (المراجعة 3)، مع أدوات القياس في الأعلى والقياسات المرسومة فوق المخطط."
  },
  {
   "file": "ex_11.png",
   "en": "Takeoff, right-hand panel: the sheet's calibration, the active takeoff item (Area-void, Aggregated Qty 125.14 m2) and the Capture into BOQ panel.",
   "ar": "الحصر، اللوحة اليمنى: معايرة الشيت، وبند الحصر الفعّال (Area-void، الكمية المجمّعة 125.14 م²)، ولوحة الالتقاط إلى جدول الكميات."
  }
 ],
 "walkthrough_stage_06": [
  {
   "file": "ex_06.png",
   "en": "Rate Build-Up of item 1.02: the two Resource-Based lines, a direct cost of 183,680.00 SAR, 15.0% markup and a selling price of 211,232.00 SAR.",
   "ar": "بناء سعر البند 1.02: سطرا \"قائم على الموارد\"، بتكلفة مباشرة 183,680.00 ريال، وهامش 15.0%، وسعر بيع 211,232.00 ريال."
  }
 ],
 "walkthrough_stage_07": [
  {
   "file": "ex_09.png",
   "en": "First-Principles Library, Exchange Rates: for the Pricing Date of 2026-09-27 the rate in force is EUR 4.20 (from 2026-09-25); the 4.10 rate starts after the Pricing Date.",
   "ar": "مكتبة المبادئ الأولى، أسعار الصرف: لتاريخ التسعير 2026-09-27 السعر الساري هو EUR 4.20 (من 2026-09-25)؛ أما السعر 4.10 فيبدأ بعد تاريخ التسعير."
  }
 ],
 "walkthrough_stage_12": [
  {
   "file": "ex_13.png",
   "en": "Indirect Budget Review: total 252,333.68 SAR (Normal Indirect 125,000.00, Risk & Contingency 69,500.13, HO Overhead 57,833.55).",
   "ar": "مراجعة الميزانية غير المباشرة: الإجمالي 252,333.68 ريال (غير مباشر عادي 125,000.00، ومخاطر واحتياطي 69,500.13، ومصاريف مكتب رئيسي 57,833.55)."
  }
 ]
}
